import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AvailableDepartment, URLUtils } from '@experian-digital/affordability-library';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalFeaturesService {
  constructor(private httpClient: HttpClient) {}

  getGlobalFeatures(): Observable<any[]> {
    const url: string = URLUtils.sanitizeUrl(ApplicationConfigService.config.apiUrl + '/api/features');
    return this.httpClient.get<AvailableDepartment[]>(url);
  }
}
